import * as React from 'react';

import { DateRangePicker, Button } from '@rematter/ui-web';
import { useAtom } from 'jotai';

import { $columnCreatedOnDateRange } from '../../../_state/salesOrdersList.state';
import { useTranslations } from '../../../i18n/useTranslations';

interface CreatedOnDateRangeColumnFilterProps {
  onClose?: () => void;
}

export const CreatedOnDateRangeColumnFilter: React.FC<
  CreatedOnDateRangeColumnFilterProps
> = ({ onClose }) => {
  const t = useTranslations();
  const [dateRange, setDateRange] = useAtom($columnCreatedOnDateRange);

  const handleReset = React.useCallback(() => {
    setDateRange(null);
  }, [setDateRange]);

  return (
    <div className="@CreatedOnDateRangeColumnFilter flex min-w-[300px] flex-col gap-4 p-3">
      <div className="pb-2">
        <DateRangePicker
          value={dateRange}
          onChange={setDateRange}
          label={t.filters.createdOnDateRange.label}
          aria-label="Filter by created on date range"
        />
      </div>

      <div className="flex justify-end gap-2 border-t border-neutral/20 pt-2">
        <Button
          variant="outline"
          onPress={handleReset}
          color="neutral"
          isDisabled={!dateRange}
        >
          {t.filters.createdOnDateRange.clear}
        </Button>
        <Button variant="solid" onPress={onClose}>
          {t.filters.createdOnDateRange.done}
        </Button>
      </div>
    </div>
  );
};
